import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { ArrowUpIconComponent } from '@itero/ui-toolkit-angular/icons';

@Component({
	selector: 'rx-intuitive-teeth-diagram-footer',
	templateUrl: './rx-intuitive-teeth-diagram-footer.component.html',
	styleUrls: ['./rx-intuitive-teeth-diagram-footer.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, TlkButtonComponent, ArrowUpIconComponent]
})
export class RxIntuitiveTeethDiagramFooterComponent {
	@Input() showBackButton = false;

	@Output() back = new EventEmitter<void>();

	onBackToToothchart(): void {
		this.back.emit();
	}
}
